export const getByPath = (dict, key, vars) => {
  const value = key
    .split(".")
    .reduce((acc, segment) => (acc == null ? acc : acc[segment]), dict);

  if (typeof value !== "string" || !vars) return value;

  return value.replace(/{{\s*(\w+)\s*}}/g, (match, name) =>
    name in vars ? String(vars[name]) : match
  );
};
